import { defineMessages } from 'react-intl';

export default defineMessages({           
    header: {
        id: "ml.quoteandbind.common.employeraffilitationcombobox.header",
        defaultMessage: "Employer or affiliation"
    },
    selectHeader: {
        id: 'ml.quoteandbind.common.employeraffilitationcombobox.selectHeader',
        defaultMessage: 'Please select your employer or affiliation'
    },
    searchPlaceHolder: {
        id: 'ml.quoteandbind.common.employeraffilitationcombobox.searchPlaceHolder',
        defaultMessage: 'Employer or affiliate name.'
    },
    selectionHeader: {
        id: 'ml.quoteandbind.common.employeraffilitationcombobox.selectionHeader',
        defaultMessage: 'Please select your specific {searchName} group from the following:'
    } 
});